import { render, staticRenderFns } from "./metrics_grade_distribution.vue?vue&type=template&id=4bf3b805&scoped=true&"
import script from "./metrics_grade_distribution.vue?vue&type=script&lang=js&"
export * from "./metrics_grade_distribution.vue?vue&type=script&lang=js&"
import style0 from "./metrics_grade_distribution.vue?vue&type=style&index=0&id=4bf3b805&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf3b805",
  null
  
)

export default component.exports